import React from "react";
import Header from "../Components/Header";
import "../assets/lib/animate/animate.css";
import "../assets/lib/swiper/swiper-bundle.min.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import HeroSection from "../Components/HeroSection";
import Chatbot from "../Components/Chatbot";
import MainContent from "../Components/MainContent";
import Footer from "../Components/Footer";

const Home = () => {
  return (
    <div>
      <Header />
      <HeroSection />
      <MainContent />
      <Footer />

      {/* <Chatbot /> */}
    </div>
  );
};

export default Home;
